/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

import * as moment from 'moment';

(function () {
    "use strict";

    angular
        .module("ROGER")

        //
        .controller("CarsToRetailSetDeliveryDateController", [
            "$scope", "$http", "$sessionStorage", "unit", "country", "$oidc",
            function ($scope, $http, $sessionStorage, unit, country, oidc) {

                $scope.$storage = $sessionStorage;

                $scope.delivery = {
                    unit: unit,
                    date: new Date()
                };

                console.log($scope.delivery);

                $scope.deliveryDateOptions = {
                    minDate: moment().startOf("month").toDate(),
                    maxDate: moment().endOf("month").toDate()
                };

                $scope.country = country;

                $scope.setDeliveryDate = function () {
                    return $http
                        .put("/api/retail/delivery-date", {}, {
                            params: {
                                deliveryId: $scope.delivery.unit.SalesOrderLineId,
                                email: $scope.delivery.unit.CustomerEmail,
                                date: $scope.delivery.date,
                                changedById: $scope.$storage.user.Id
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function () {
                            $scope.$close();
                        }, function () {
                            $scope.$dismiss();
                        });
                };
            }
        ]);

})();
